import React, { Component } from 'react';

class Interests extends Component {
	render() {
            return (
		<div class="flex-column">
		    <h3>Interests</h3>
		    <ul>
			<li>Structure-preserving discretisations</li>
			<li>Interdisciplinary mathematical modelling</li>
			<li>Numerical analysis of finite element methods</li>
			<li>Multiscale methods</li>
		    </ul>
		</div>
	    );
  	}
}

export default Interests;
